import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import "antd/es/form/style";
import _Form from "antd/es/form";
import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/grid/style";
import _Grid from "antd/es/grid";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState, useRef, useEffect, useMemo, useReducer, cloneElement, isValidElement } from 'react';
import { LocaleContext } from '../../locale';
import Button from '../../button';
import { calcNamePath, getRuleValidation, calcShouldRender } from '../../utils/form-utils';
import FormContext from '../../form-context';
import invariant from 'invariant';
import './style/index.less';
var useBreakpoint = _Grid.useBreakpoint;

function specialDisplayIndex(index) {
  return index < 10 ? "0".concat(index) : index;
}

var Step = function Step(_ref) {
  var parentName = _ref.parentName,
      name = _ref.name,
      label = _ref.label,
      editButtonLabel = _ref.editButtonLabel,
      getButtonDisabledState = _ref.getButtonDisabledState,
      disableEditButton = _ref.disableEditButton,
      edit = _ref.edit,
      preview = _ref.preview,
      index = _ref.index,
      total = _ref.total,
      handleNextProp = _ref.handleNext,
      handleEditProp = _ref.handleEdit,
      handleNextStep = _ref.handleNextStep,
      showLastIndex = _ref.showLastIndex,
      shouldScroll = _ref.shouldScroll,
      children = _ref.children,
      shouldRender = _ref.shouldRender,
      subscribedFields = _ref.subscribedFields,
      buttonText = _ref.buttonText,
      validationRule = _ref.validationRule,
      asserts = _ref.asserts,
      dependencies = _ref.dependencies,
      shouldRenderCode = _ref.shouldRenderCode;

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage,
      currentLang = _useContext.currentLang;

  var _useContext2 = useContext(FormContext),
      continueText = _useContext2.continueText,
      submitText = _useContext2.submitText,
      submitting = _useContext2.submitting,
      form = _useContext2.form,
      showSubmitButton = _useContext2.showSubmitButton,
      getRuleValidationApi = _useContext2.getRuleValidationApi,
      getScrollContainer = _useContext2.getScrollContainer,
      registerDependencies = _useContext2.registerDependencies;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      showButton = _useState2[0],
      setShowButton = _useState2[1];

  var containerRef = useRef(null);

  var _useReducer = useReducer(function (r) {
    return r + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _ = _useReducer2[0],
      dispatch = _useReducer2[1];

  invariant(!validationRule || getRuleValidationApi, 'Please provide getRuleValidationApi in Form props');
  useEffect(function () {
    if (shouldRender || getButtonDisabledState || shouldRenderCode) {
      registerDependencies(Array.isArray(subscribedFields) ? subscribedFields : 'SUBSCRIBE_ALL', dispatch);
    }

    if (asserts === null || asserts === void 0 ? void 0 : asserts.length) {
      var dependentField = asserts.map(function (_ref2) {
        var field = _ref2.field;
        return field;
      });
      registerDependencies(dependentField, dispatch);
    }
  }, []);
  var pName = useMemo(function () {
    return calcNamePath(parentName, name);
  }, [parentName, name]);
  var buttonDisabled = getButtonDisabledState && form && getButtonDisabledState(form);

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md;

  useEffect(function () {
    var _containerRef$current, _containerRef$current2, _containerRef$current3;

    if (md || !(shouldScroll && edit)) return;
    var scrollContainer = getScrollContainer() || window;
    (containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetTop) ? scrollContainer.scrollTo({
      top: (containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.offsetTop) - 50,
      behavior: 'smooth'
    }) : containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.scrollIntoView();
  }, [shouldScroll, edit]);
  var displayTotal = showLastIndex ? total : total - 1;

  var transformChildren = function transformChildren() {
    if (Array.isArray(children)) {
      return children.map(function (c, index) {
        var _c$type;

        if (['Igloo_Free_Form_Item', 'Igloo_Free_Form_Section', 'Igloo_Free_Form_AddabledSection'].includes(c === null || c === void 0 ? void 0 : (_c$type = c.type) === null || _c$type === void 0 ? void 0 : _c$type.displayName)) {
          return /*#__PURE__*/cloneElement(c, _objectSpread(_objectSpread({
            key: index
          }, c.props), {}, {
            parentName: pName,
            setShowStepButton: setShowButton,
            preview: preview
          }));
        }

        return c;
      });
    }

    return /*#__PURE__*/isValidElement(children) ? /*#__PURE__*/cloneElement(children, _objectSpread(_objectSpread({}, children.props), {}, {
      parentName: pName,
      setShowStepButton: setShowButton,
      preview: preview
    })) : children;
  };

  var handleEdit = function handleEdit() {
    return handleEditProp && handleEditProp(index);
  };

  var handleNext = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _allFields$filter;

      var allFields, allValues, fields, res, errors;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              allFields = (form === null || form === void 0 ? void 0 : form.getFieldsError()) || [];
              allValues = form === null || form === void 0 ? void 0 : form.getFieldsValue(true);
              fields = allFields === null || allFields === void 0 ? void 0 : (_allFields$filter = allFields.filter(function (_ref4) {
                var name = _ref4.name;
                return name.join().startsWith(pName === null || pName === void 0 ? void 0 : pName.join());
              })) === null || _allFields$filter === void 0 ? void 0 : _allFields$filter.map(function (_ref5) {
                var name = _ref5.name;
                return name;
              });
              _context.prev = 3;
              _context.next = 6;
              return form === null || form === void 0 ? void 0 : form.validateFields(fields);

            case 6:
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](3);
              form === null || form === void 0 ? void 0 : form.scrollToField(_context.t0.errorFields[0].name);
              return _context.abrupt("return");

            case 12:
              if (!(validationRule && getRuleValidationApi)) {
                _context.next = 26;
                break;
              }

              _context.prev = 13;
              _context.next = 16;
              return getRuleValidation(getRuleValidationApi, validationRule, allValues, currentLang);

            case 16:
              res = _context.sent;

              if (!(Array.isArray(res) && res.length)) {
                _context.next = 21;
                break;
              }

              form === null || form === void 0 ? void 0 : form.setFields(res);
              form === null || form === void 0 ? void 0 : form.scrollToField(res[0].name);
              return _context.abrupt("return");

            case 21:
              _context.next = 26;
              break;

            case 23:
              _context.prev = 23;
              _context.t1 = _context["catch"](13);
              return _context.abrupt("return");

            case 26:
              if (!(typeof handleNextProp === 'function')) {
                _context.next = 37;
                break;
              }

              _context.prev = 27;
              _context.next = 30;
              return handleNextProp(form === null || form === void 0 ? void 0 : form.getFieldsValue(fields));

            case 30:
              errors = _context.sent;

              if (Array.isArray(errors)) {
                form === null || form === void 0 ? void 0 : form.setFields(errors);
              }

              _context.next = 37;
              break;

            case 34:
              _context.prev = 34;
              _context.t2 = _context["catch"](27);
              return _context.abrupt("return");

            case 37:
              handleNextStep && handleNextStep(fields);

            case 38:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 8], [13, 23], [27, 34]]);
    }));

    return function handleNext() {
      return _ref3.apply(this, arguments);
    };
  }();

  if (!calcShouldRender(pName, dependencies, asserts, shouldRender, shouldRenderCode, form)) {
    return null;
  }

  return _jsxs("div", {
    className: 'igloo-freeform-step-container',
    ref: containerRef,
    children: [label && _jsxs("div", {
      className: "igloo-freeform-step-label",
      children: [_jsxs("div", {
        children: [(index !== total - 1 || showLastIndex) && _jsx("span", {
          className: "igloo-freeform-step-label-index",
          children: specialDisplayIndex(index + 1)
        }), _jsx("span", {
          className: "igloo-freeform-step-label-text",
          children: label
        })]
      }), !preview && (index !== total - 1 || showLastIndex) && _jsx("div", {
        className: "igloo-freeform-step-label-step-count",
        children: formatMessage({
          id: "{currentStep} of {allSteps}",
          values: {
            currentStep: index + 1,
            allSteps: displayTotal
          }
        })
      }), preview && _jsx(Button, {
        type: "link",
        className: "igloo-freeform-step-label-edit",
        onClick: handleEdit,
        disabled: disableEditButton,
        children: editButtonLabel || formatMessage({
          id: 'Edit'
        })
      })]
    }), (edit || preview) && _jsxs("div", {
      className: 'igloo-freeform-step-content',
      children: [_jsx(_Row, {
        gutter: [32, preview ? 16 : 24],
        children: transformChildren()
      }), edit && index !== total - 1 && showButton && _jsx(_Row, {
        children: _jsx(Button, {
          onClick: handleNext,
          className: 'igloo-freeform-step-button',
          type: "primary",
          disabled: buttonDisabled,
          children: buttonText || continueText || formatMessage({
            id: 'Continue'
          })
        })
      }), edit && index === total - 1 && showButton && showSubmitButton && _jsx(_Form.Item, {
        style: {
          marginBottom: 0
        },
        children: _jsx(Button, {
          type: "primary",
          htmlType: "submit",
          className: 'igloo-freeform-step-button',
          loading: submitting,
          disabled: buttonDisabled,
          children: buttonText || submitText || formatMessage({
            id: 'Submit'
          })
        })
      })]
    }), !edit && !preview && _jsx(_Divider, {
      className: "igloo-freeform-step-divider"
    })]
  });
};

export default Step;
Step.displayName = 'Igloo_Free_Form_Step';